<template>
  <div v-if="active">
    <vm-table
        ref="vmTable1"
        :filter.sync="filter"
        module="basic"
        url="soas/receiveDetail"
        @select="selectHandle"
        @select-all="selectHandle">
      <!-- Search Begin -->
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="采购订单">
            <el-input
                v-model.trim="filter.evaluate"
                type="textarea"
                autosize
                placeholder="请输入采购订单号"
                clearable/>
          </vm-search>
          <vm-search label="送货单号">
            <el-input
                v-model.trim="filter.asnNo"
                type="textarea"
                autosize
                placeholder="请输入送货单号"
                clearable/>
          </vm-search>
          <vm-search label="物料编号">
            <el-input v-model.trim="filter.partNo" placeholder="请输入物料编号" clearable/>
          </vm-search>
          <vm-search label="物料名称">
            <el-input v-model.trim="filter.partNameSpec" placeholder="请输入物料名称" clearable/>
          </vm-search>
          <vm-search label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </vm-search>
          <vm-search label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编号" clearable/>
          </vm-search>
          <vm-search label="对账状态">
            <el-select v-model.trim="filter.soaStatus" placeholder="请选择对账状态">
              <el-option label="未对账" :value="'未对账'"/>
              <el-option label="部分对账" :value="'部分对账'"/>
              <el-option label="已对账" :value="'已对账'"/>
            </el-select>
          </vm-search>
          <vm-search label="直发标识">
            <el-select v-model.trim="filter.straightMark">
              <el-option label="全部" value=""/>
              <el-option label="直发" value="Z001"/>
              <el-option label="非直发" value="1000"/>
            </el-select>
          </vm-search>
          <vm-search label="暂估类型">
            <el-select v-model.trim="filter.priceFlag">
              <el-option label="全部" value=""/>
              <el-option label="暂估" value="暂估"/>
              <el-option label="信息" value="信息"/>
            </el-select>
          </vm-search>
        </div>
        <div>
          <vm-search label="到货日期：">
            <div class="block">
              <el-date-picker
                  v-model="filter.arriveDateBegin"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.arriveDateEnd"
                  style="width:163px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
          <vm-search label="创建日期：">
            <div class="block">
              <el-date-picker
                  v-model="filter.createDateBegin"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.createDateEnd"
                  style="width:163px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
        </div>
      </template>
      <!-- Search End -->
      <div slot="toolbar">
        <!--        <el-button type="primary" @click="clickHandle1">查看汇总送货单</el-button>-->
        <el-button type="primary" :disabled="!selection.length" @click="handle()">
          选中对账
        </el-button>
        <!--        <el-button type="primary" @click="allHandle">全部对账</el-button>-->
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
      </div>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column prop="asnNo" align="center" width="140" label="送货单号"/>
      <el-table-column prop="asnRowIndex" align="center" width="60" label="行号"/>
      <el-table-column prop="evaluate" align="center" width="120" label="采购订单号"/>
      <el-table-column prop="poDetailRowNo" align="center" width="80" label="行号"/>
      <el-table-column prop="partNo" width="100" align="center" label="物料编号"/>
      <el-table-column prop="partNameSpec" show-overflow-tooltip label="物料名称"/>
      <el-table-column
          prop="buyUserName"
          width="100"
          align="center"
          show-overflow-tooltip
          label="采购组"/>
      <el-table-column
          prop="supplierNo"
          show-overflow-tooltip
          width="90"
          align="center"
          label="供应商编号"/>
      <el-table-column
          prop="supplierName"
          show-overflow-tooltip
          align="center"
          width="90"
          label="供应商名称"/>
      <el-table-column label="直发标识" width="80" align="center">
        <template slot-scope="scope">
          <span>{{scope.row.straightMark === "1000" ? "非直发" : "直发"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdTime" align="center" width="180" label="送货单创建日期"/>
      <el-table-column prop="arrivedTime" align="center" width="180" label="送货单到货日期"/>
      <el-table-column prop="sumQuantity" align="center" width="90" label="送货单数量"/>
      <el-table-column prop="instockQuantity" align="center" width="105" label="送货单入库数量"/>
      <el-table-column prop="leftQuantity" align="center" width="105" label="剩余可对账数量"/>
      <el-table-column prop="priceFlag" align="center" width="90" label="暂估类型"/>
      <el-table-column prop="soaStatus" align="center" width="90" label="状态"/>
    </vm-table>
    <reconcile-order-edit ref="reconcileOrderEdit" @save-success="getList(1)"/>
  </div>
  <div v-else>
    <vm-table
        ref="vmTable2"
        :filter.sync="filter1"
        module="basic"
        url="soas/receive"
        @select="selectHandle"
        @select-all="selectHandle">
      <!-- Search Begin -->
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="送货单号">
            <el-input v-model.trim="filter1.asnNo" placeholder="请输入送货单号" clearable/>
          </vm-search>
          <vm-search label="对账状态">
            <el-select v-model.trim="filter1.soaStatus" placeholder="请选择对账状态">
              <el-option label="未对账" :value="1"/>
              <el-option label="部分对账" :value="2"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="45"/>
      <el-table-column prop="asnNo" label="送货单号"/>
      <el-table-column prop="soaStatus" align="center" width="90" label="状态"/>
    </vm-table>
    <reconcile-order-edit ref="reconcileOrderEdit" @save-success="getData(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ReconcileOrderEdit from "./ReconcileOrderEdit.vue";
  import LoginUtil from "@/util/loginUtil";

  export default {
    components: {VmTable, VmSearch, ReconcileOrderEdit},
    data() {
      return {
        userType: LoginUtil.getUserType(),
        name: LoginUtil.getName(),
        exportLoading: false,
        filter: {
          evaluate: "",
          asnNo: "",
          partNo: "",
          partNameSpec: "",
          soaStatus: "未对账",
          straightMark: "",
          buyUserName: "",
          supplierNo: "",
          arriveDateEnd: "",
          arriveDateBegin: "",
          createDateBegin: "",
          createDateEnd: "",
          priceFlag:"",
        },
        filter1: {
          asnNo: "",
          soaStatus: "",
        },
        active: true,
        selection: [],
      };
    },

    mounted() {
      if (this.userType === 1) {
        this.filter.buyUserName = this.name;
      }
      this.getList(1);
    },

    methods: {
      clickHandle1() {
        this.active = false;
        this.$nextTick(() => {
          this.getData(1);
        });
      },
      clickHandle2() {
        this.active = true;
        this.$nextTick(() => {
          this.getList(1);
        });
      },
      // 查看详细送货单
      getList(pageNum) {
        this.$refs.vmTable1.getList(pageNum);
        this.selection = [];
      },

      // 查看汇总送货单
      getData(pageNum) {
        this.$refs.vmTable2.getList(pageNum);
        this.selection = [];
      },

      selectHandle(selection) {
        this.selection = selection;
      },
      handle() {
        if (this.selection.length > 333) {
          this.$message.error("对账单不可超过333条");
        }else {
          this.$refs.reconcileOrderEdit.open(0, this.selection);
        }
      },
      checkHandle() {
        let asnNos = [];
        this.selection.forEach((item) => {
          asnNos.push(item.asnNo);
        });
        this.$http.post("basic", "soas/receiveDetail/list", asnNos).then((res) => {
          if (res.success) {
            this.$refs.reconcileOrderEdit.open(0, res.data);
          }
        });
      },

      // 全部对账
      allHandle() {
        this.$http.get("basic", "soas/batch").then((res) => {
          if (res.success) {
            this.$refs.reconcileOrderEdit.open(0, res.data);
          }
        });
      },

      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "soas/receiveDetailExport", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
.el-table--border .el-table__cell:first-child .cell {
  padding: 0 14px;
}
</style>
